<button mat-icon-button class="actions-buttons" *ngIf="showActionsForSelectedZCVersion"
    [disabled]="zoningCode.isDeleting">
    <mat-icon matTooltip="Check status" (click)="getZCVersionStatistics($event)" class="actions-mat-icons">info
    </mat-icon>
</button>